<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog">
      <v-layout row justify-center>
        <v-card max-width="400">
          <v-card-title class="pb-0 mb-0" primary-title>
            <v-layout>
              <h3>Enviar pedido por WhatsApp</h3>
              <v-spacer></v-spacer>
              <v-icon @click="dialog = false">mdi-close</v-icon>
            </v-layout>
          </v-card-title>

          <v-card-text>
            Confirma envio do pedido para o número +55 {{ orderData ? orderData.comprador_telefone : '' }}?
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              style="text-transform: none;"
              color="primary"
              depressed
              round
              outline
              width="100"
              height="40"
              class="mr-1"
              @click="dialog = false"
            >
              Fechar
            </v-btn>
            <v-btn
              style="text-transform: none;"
              color="primary"
              depressed
              round
              width="100"
              :loading="loading"
              dark
              height="40"
              @click="handleSendOrderByWhats"
            >
              Confirmar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-layout>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  props: ['dialogConfirmationWhats', 'orderData'],
  data() {
    return {
      dialog: false,
      loading: false,
    };
  },
  watch: {
    dialogConfirmationWhats(v) {
      this.dialog = v;
    },
    dialog(v) {
      if (!v) this.$emit('closeDialog');
    },
  },
  methods: {
    async handleSendOrderByWhats() {
      this.loading = true;
      let params = {
        hash_pedido: this.orderData.hash_pedido,
      };
      await this.$store
        .dispatch('sendOrderByWhats', params)
        .then(resp => {
          this.dialog = false;
          this.loading = false;
          this.$store.dispatch('openSnackbar', {
            message: 'Pedido enviado por WhatsApp com sucesso.',
            color: 'success',
          });
        })
        .catch(e => {
          this.$store.dispatch('openSnackbar', {
            message: 'Erro inesperado.',
            color: 'error',
          });
          this.loading = false;
        });
      this.dialog = false;
      this.loading = false;
    },
  },
};
</script>
